module.exports = __webpack_public_path__ + "img/check.b79a8470.svg";